<script lang="ts">
  let searched = '';
  export let placeholder: string;
</script>

<label for="search-input" class="relative flex-grow">
  <div>
    <i class="fa-solid fa-magnifying-glass absolute left-[14px] top-[10px] h-4 w-4 text-gray-500" />
    <input
      on:input
      type="text"
      id="search-input"
      bind:value={searched}
      {placeholder}
      class="!mx-0 !my-0 !h-9 !w-full rounded-lg !border !border-gray-300 !bg-white !py-[10px] !pl-[38px] !text-sm !font-medium"
    />
  </div>
</label>
